import type { DefaultElementProps } from '../DefaultElementProps'
import { useLoading } from '../Loading'
import { PlaceholderInternal } from './PlaceholderInternal'

export { Fill as PlaceholderFill } from './Fill'

export { PlaceholderInternal }

type Props = DefaultElementProps & {
	isLoading?: boolean
	isLoadingManual?: boolean
	lines?: number
	width?: number | string
}

export const Placeholder = ({
	isLoading,
	children,
	isLoadingManual,
	lines = 1,
	width = '80%',
	className,
	style,
}: Props) => {
	const isInternalLoading = useLoading()

	if (isLoadingManual === undefined ? isInternalLoading || isLoading : isLoadingManual) {
		return <PlaceholderInternal lines={lines} width={width} className={className} style={style} />
	}

	return children ? children : null
}
